import React, { useEffect, useState } from 'react';
import { Fade } from '@material-ui/core';
import cn from 'classnames';
import { useAppContext } from 'contexts/AppContext';
import defaultLocales from 'globals/locales/default';
import { useAsyncWait } from 'globals/hooks/useAsyncWait';
import FsMagicLinkForm from 'ui-elements/forms/FsMagicLinkForm';
import { isSuccessState } from 'globals/utils';
import FsPaper from 'ui-elements/main-elements/FsPaper';
import FsDefaultFallbackComponent from 'ui-elements/loaders/FsDefaultFallbackComponent';
import { observer } from 'mobx-react';
import { useStyles } from './MagicLink.style';

interface MagicLinkProps {
  withMarginTop?: boolean;
}

const MagicLink: React.FC<MagicLinkProps> = ({ withMarginTop = false }) => {
  const {
    magicLink: { status, getMagicLinkUrl, init: initStore },
  } = useAppContext();
  const [inStatus, setInStatus] = useState<boolean>(false);
  const { paper: paperClass } = useStyles();

  useAsyncWait(setInStatus);

  useEffect(() => {
    initStore();
  }, [initStore]);

  if (!isSuccessState(status))
    return (
      <FsDefaultFallbackComponent
        status={status}
        data-test="default-fallback-component"
      />
    );

  return (
    <Fade in={inStatus} timeout={1000}>
      <FsPaper
        className={cn({ [paperClass]: withMarginTop })}
        title={defaultLocales.inviteCustomerWithMagicLink}
      >
        <FsMagicLinkForm url={getMagicLinkUrl() || ''} />
      </FsPaper>
    </Fade>
  );
};

export default observer(MagicLink);
